import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import CtaLink from 'components/essentials/Cta/CtaLink';
import DesktopNavLinkGroupItem from './DesktopNavLinkGroupItem';
const DesktopNavLinkGroup = t0 => {
  const $ = _c(11);
  const {
    categoryId: t1,
    items: t2,
    ctaLabel,
    ctaUrl,
    secondaryItems: t3,
    selectedItem,
    setIsTitleHovered
  } = t0;
  const categoryId = t1 === undefined ? "" : t1;
  const items = t2 === undefined ? [] : t2;
  const secondaryItems = t3 === undefined ? [] : t3;
  const containerRef = useRef(null);
  const t4 = "DesktopNavLinkGroup";
  const t6 = items.map(t5 => {
    const {
      customContent,
      id,
      isNew,
      items: nestedItems,
      label,
      url
    } = t5;
    return <DesktopNavLinkGroupItem categoryId={categoryId} containerRef={containerRef} hasNestedContent={!!nestedItems?.length || !!customContent} id={id} isNew={isNew} key={id} label={label} selectedItem={selectedItem} setIsTitleHovered={setIsTitleHovered} url={url} />;
  });
  let t7;
  if ($[0] !== t6) {
    t7 = <ul className="m-0 p-0 max-h-[337px] overflow-x-auto" ref={containerRef}>{t6}</ul>;
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] !== ctaLabel || $[3] !== ctaUrl) {
    t8 = !!ctaLabel && !!ctaUrl && <div className="mb-5 mt-5 ml-3.5"><CtaLink to={ctaUrl} styling="solid-button" color="brand" size="sm" spacing="xs">{ctaLabel}</CtaLink></div>;
    $[2] = ctaLabel;
    $[3] = ctaUrl;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const t9 = "m-0 p-0";
  const t11 = secondaryItems.map(t10 => {
    const {
      customContent: customContent_0,
      id: id_0,
      isNew: isNew_0,
      items: nestedItems_0,
      label: label_0,
      url: url_0
    } = t10;
    return <DesktopNavLinkGroupItem categoryId={categoryId} containerRef={containerRef} hasNestedContent={!!nestedItems_0?.length || !!customContent_0} id={id_0} isNew={isNew_0} key={id_0} label={label_0} selectedItem={selectedItem} setIsTitleHovered={setIsTitleHovered} url={url_0} />;
  });
  let t12;
  if ($[5] !== t11) {
    t12 = <ul className={t9} ref={containerRef}>{t11}</ul>;
    $[5] = t11;
    $[6] = t12;
  } else {
    t12 = $[6];
  }
  let t13;
  if ($[7] !== t12 || $[8] !== t7 || $[9] !== t8) {
    t13 = <div className={t4}>{t7}{t8}{t12}</div>;
    $[7] = t12;
    $[8] = t7;
    $[9] = t8;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  return t13;
};
DesktopNavLinkGroup.propTypes = {
  categoryId: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    isNew: PropTypes.bool,
    label: PropTypes.string,
    url: PropTypes.string
  })),
  ctaLabel: PropTypes.string,
  ctaUrl: PropTypes.string,
  secondaryItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    isNew: PropTypes.bool,
    label: PropTypes.string,
    url: PropTypes.string
  })),
  selectedItem: PropTypes.string,
  setIsTitleHovered: PropTypes.func
};
export default DesktopNavLinkGroup;